<template>
  <div class="content-panel">
    <el-form label-width="20px">
      <el-form-item> 
        <el-checkbox v-model="form.nameCheck" label="校对品名(不存在的品名原样输出)" size="large" @change="nameCheckChange"/>
        <el-checkbox v-model="form.nameCheckIgnore" label="校对品名(不存在的品名直接忽略)" size="large" @change="nameCheckIgnoreChange"/>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="form.qualityCheck" label="校对申报数量" size="large"/>
        <div>数量大于
          <el-input type="number" v-model="form.qualityLimit" size="mini" min="0" class="inline-input"
                    :disabled="!form.qualityCheck"></el-input>
          时，校正为
          <el-input type="number" v-model="form.qualityStart" size="mini" min="0" class="inline-input"
                    :disabled="!form.qualityCheck"></el-input>
          到
          <el-input type="number" v-model="form.qualityEnd" size="mini" min="0" class="inline-input"
                    :disabled="!form.qualityCheck"></el-input>
          的随机数；
        </div>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="form.priceCheck" label="校对申报单价" size="large"/>
        <div>价格大于
          <el-input type="number" v-model="form.priceLimit" size="mini" min="0" class="inline-input"
                    :disabled="!form.priceCheck"></el-input>
          时，校正为
          <el-input type="number" v-model="form.priceStart" size="mini" min="0" class="inline-input" :disabled="!form.priceCheck"></el-input>
          到
          <el-input type="number" v-model="form.priceEnd" size="mini" min="0" class="inline-input" :disabled="!form.priceCheck"></el-input>
          的随机数；
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="onSubmit" id="btnDeclareCheckSubmit"><i
            class="el-icon-check"></i><span>{{ msg('确定') }}</span></el-button>
        <el-button size="mini" v-on:click="$emit('close-dg')">{{ msg('取消') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { Loading } from 'element-ui';
export default {
  name: 'StockDeclareCheck',
  props: {
    // stockIds: {
    //   type: String
    // }
  },
  data() {
    return {
      loading: null,
      form: {
        nameCheck: false,
        nameCheckIgnore: false,
        qualityCheck: false,
        qualityLimit: null,
        qualityStart: null,
        qualityEnd: null,
        priceCheck: false,
        priceLimit: null,
        priceStart: null,
        priceEnd: null,
      }
    }
  },
  computed: {},
  mounted: function () {
    // if (!this.stockIds) {
    //   this.$message.warning(this.msg("请选择要操作的订单"));
    //   return;
    // }
    // this.form.stockIds = this.stockIds;
  },
  methods: {
    init(stockIds){
      this.form.stockIds = stockIds;
    },
    onSubmit() {
      var _this = this;
      if (!this.form.stockIds) {
        this.$message.warning(this.msg("请选择要操作的订单"));
        return;
      }
      if (!this.form.nameCheck && !this.form.nameCheckIgnore && !this.form.qualityCheck && !this.form.priceCheck) {
        _this.$message.warning(_this.msg("请至少选择一个校对项！"));
        return;
      }
      if (this.form.qualityCheck) {
        if (this.form.qualityLimit == null || this.form.qualityStart == null || this.form.qualityEnd == null) {
          _this.$message.warning(_this.msg("请填写完整校对条件！"));
          return;
        }
      }
      if (this.form.priceCheck) {
        if (this.form.priceLimit == null || this.form.priceStart == null || this.form.priceEnd == null) {
          _this.$message.warning(_this.msg("请填写完整校对条件！"));
          return;
        }
      }
      this.loading = Loading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.5)",
        target: document.querySelector('#btnDeclareCheckSubmit')
      });
      this.$axios.post(this.$kit.api.updateColumn.stockDeclareCheck, JSON.stringify(this.form))
          .then((result) => {
            if(this.loading){
              this.loading.close();
              this.loading = null;
            }
            if (result.status) {
              _this.$message.success(_this.msg("校对成功"));
              _this.$emit("close-dg", true);
            } else {
              _this.$message.error(_this.msg("校对失败：" + result.message));
            }
          }).catch((error) => {
            this.$message("网络请求错误，请检查网络连接");
            console.log(error);
            if(this.loading){
              this.loading.close();
              this.loading = null;
            }
          });
    },
    nameCheckChange(value) {
      this.form.nameCheck = value;
      this.form.nameCheckIgnore = !value;
    },
    nameCheckIgnoreChange(value) {
      this.form.nameCheckIgnore = value;
      this.form.nameCheck = !value;
    }
  }
}
</script>

<style scoped lang="scss">
.inline-input {
  display: inline-block;
  width: 100px;
}
</style>
